import React from "react";

const FormError = ({ error, className, ...props }) => (
  <p className={`${className} text-red-600 mt-1 mb-2 text-xs`} {...props}>
    {error}
  </p>
);

export default FormError;
